import type { Instance, Props } from 'tippy.js';
import createTippy from 'tippy.js';

export const tippy = (node: HTMLElement & { _tippy?: Instance }, options?: Partial<Props>) => {
	function destroy() {
		node._tippy && node._tippy.destroy();
	}

	function update(options?: Partial<Props>) {
		if (!options) {
			return node._tippy && destroy();
		}
		node._tippy && destroy();
		node._tippy = createTippy(node, options);
	}

	update(options);

	return { update, destroy };
};
